import { Suspense, lazy } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router';

import '@bluecodecom/fonts';

import { LoaderProvider } from '@bluecodecom/loader';

import { ThemeProvider } from '@bluecodecom/theme';

import { ApolloProviders } from '@bluecodecom/onboarding-webview/features/apollo';

import './i18n';

const App = lazy(() => import('./app'));

declare global {
  interface Window {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    fbq?: any;
  }
}

createRoot(document.getElementById('root') as HTMLElement).render(
  <LoaderProvider>
    <ThemeProvider observe>
      <BrowserRouter>
        <ApolloProviders.Apollo>
          <Suspense>
            <App />
          </Suspense>
        </ApolloProviders.Apollo>
      </BrowserRouter>
    </ThemeProvider>
  </LoaderProvider>,
);
